import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18View1 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M9.001 6.08a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0 1.2a1.8 1.8 0 1 1 .001 3.599 1.8 1.8 0 0 1-.001-3.599"
      }), /*#__PURE__*/jsx("path", {
        d: "M9.001 3.21c-2.297 0-4.4 1.718-6.217 4.25a2.76 2.76 0 0 0 .002 3.243c1.798 2.52 3.914 4.247 6.215 4.247 2.298 0 4.4-1.718 6.218-4.25.69-.97.69-2.27.001-3.238C13.401 4.928 11.3 3.21 9.001 3.21m0 1.2c1.788 0 3.634 1.51 5.243 3.75.392.55.392 1.29-.001 1.842C12.635 12.241 10.789 13.75 9 13.75s-3.649-1.516-5.241-3.748c-.4-.552-.4-1.292-.003-1.84C5.367 5.92 7.214 4.41 9 4.41z"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18View1$1 = Svg18View1;

export { Svg18View1$1 as default };
